export const RECORD_TYPE = [
  {
    id: 'title_inspection',
    type: 'INSPECTION',
  },
  {
    id: 'title_observation',
    type: 'OBSERVATION',
  },
  {
    id: 'title_incident',
    type: 'INCIDENT',
  },
];

export const MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];
